import type { Math } from "@pdfking/quantity"
import { NullQ } from "@pdfking/structs"

import type { GrowLayout } from "#public"
import { GrowLayoutAxis, GrowLayoutExtent } from "#public"

/** What the whole grow comes to along the opening and across it; a grow
 * that leaves an axis unsaid is a mistake in its template. */
export const GrowLayoutSize = (layout: GrowLayout): { along: Math; across: Math } => {
  const own = GrowLayoutAxis(layout)
  const along = GrowLayoutExtent(layout, "along", own)
  const across = GrowLayoutExtent(layout, "across", own)
  if (NullQ(along) || NullQ(across)) throw new Error("grow layout names no size")
  return { along, across }
}
